import { render, staticRenderFns } from "./ChartjsHorizontalBarChartRisks.vue?vue&type=template&id=12a63eca&"
import script from "./ChartjsHorizontalBarChartRisks.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartRisks.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartRisks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports